<template>
    <modal :show-title="true" :size="'large'" :header-close-icon="false">
        <div slot="header">
            <h5 class="modal-title">{{$t('attenzione_label')}}</h5>
        </div>
        <div slot="body" class="text-center">
            <p>
                <b v-html="this.error ? this.error : $t('ordine_tempo_esaurito_label')">
                </b>
            </p>
            <div class="alert alert-danger" v-if="this.errors.length">
                <ul>
                    <li v-for="error in errors">
                        {{error}}
                    </li>
                </ul>
            </div>
            <div class="title" v-if="this.hours.length">
                {{$t('ordine_scegli_orario_label')}}
            </div>
            <options-carousel
                v-if="this.entries.length"
                ref="carousel"
                :initial-idx="this.index_first"
                :entries="this.entries"
                @onSnapToItem="this.onSnapToItem"
            />
            {{$t('carrello.prd_non_disponibili_msg')}}.
        </div>
        <div slot="footer" class="d-flex flex-fill flex-column">
            <button type="button" class="btn btn-primary w-100" v-if="this.entries.length" @click="confirm()"
                    :disabled="this.loading">
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" v-if="this.loading"></span>
                {{$t('btn_conferma')}}
            </button>
            <p class="my-2" v-if="this.entries.length">
                {{$t('vai_alle')}}
            </p>
            <button type="button" class="btn btn-default w-100" @click="navigate()">
                {{$t('ordine_opzioni')}}
            </button>
        </div>
    </modal>
</template>

<script>
import moment from 'moment';
import {mapActions, mapState} from 'vuex';

import {getSurvivedItems, getTimezone} from '../../../libraries/utils';
import {addToBlockingList} from '../../../api/account';
import {lv3 as getLv3} from "../../../api/restaurant/shifts";

import Modal from '../../partials/Modal';
import OptionsCarousel from "../../orders/partials/options/OptionsCarousel";

export default {
    name: "ModalCartExpired",
    components: {OptionsCarousel, Modal},
    data() {
        return {
            hours_index: 0,

            loading: false,
            errors: [],

            hours: []
        }
    },
    mounted() {
        this.fetch();
    },
    computed: {
        configuration_service: function () {
            if (this.order.type === 'TAKEAWAY') {
                return this.locale.configurazione_takeaway;
            }

            return this.locale.configurazione_delivery;
        },
        index_first: function () {
            const time_to_compare = moment(this.order.date).format("HH:mm");

            return this.hours.findIndex(function (hour) {
                return time_to_compare <= hour.from;
            });
        },
        entries: function () {
            return this.hours.map((ora) => ({
                primaryText: ['DELIVERY', 'DIL'].includes(this.order.type) ? ora.from + ' - ' + ora.to : ora.from,
                secondaryText: null,
                value: ora,
            }));
        },
        ...mapState('global', {
            error: state => state.modal_cart_expired_error
        }),
        ...mapState('order', {
            order: state => state
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('auth', {
            user: state => state
        })
    },
    methods: {
        fetch: function () {
            let id_consegna_citta = null;
            if(this.order.address){
                id_consegna_citta = this.order.address.consegneCittaTrovate;
                if(!id_consegna_citta) id_consegna_citta = this.order.address.id_consegna_citta;
            }

            getLv3(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    tipo: this.order.type,
                    id_consegna_citta,
                    id_consegna_zona: this.order.address ? this.order.address.id_consegna_zona : null,
                    data: moment(this.order.date).format('YYYY-MM-DD'),
                },
                this.user.api_key,
            ).then((configurazione) => {
                this.hours = configurazione.fasce;
                if (this.index_first >= 0) {
                    this.hours_index = this.index_first;
                    this.$refs.hours_swiper.$swiper.slideTo(this.hours_index);
                }
            }).catch((e) => {
            }).finally(() => {
                //this.showLoading(false);
            });
        },
        onSnapToItem: function (i) {
            this.hours_index = i;
        },
        navigate: function () {
            this.showModalCartExpired({
                show: false,
                error: ''
            });
            this.$router.push({name: 'orders'});
        },
        confirm: function () {
            this.loading = true;
            this.errors = [];
            addToBlockingList(this.language, {
                id_ristorante: this.id_ristorante,
                email: this.user.email,
                api_key: this.user.api_key,
                data: (moment(this.order.date).format("YYYY-MM-DD") + " " + this.hours[this.hours_index].from + ":00"),
                id_orario: this.hours[this.hours_index].id_orario,
                timezone: getTimezone()
            }).then((response) => {
                this.setOrderOptions({
                    type: this.order.type,
                    date: this.order.date.split(' ')[0] + ' ' + this.hours[this.hours_index].from + ':00',
                    id_menu: this.hours[this.hours_index].id_menu,
                    id_orario: this.hours[this.hours_index].id_orario,
                    f_appena_possibile: this.order.f_appena_possibile,
                    n_persone: this.order.n_persone,
                    fine_fascia: ['DELIVERY', 'DIL'].includes(this.order.type) ? this.hours[this.hours_index].to + ':00' : null,
                    id_locale: this.locale.id
                });

                if (this.order.items.length) {
                    const survived_items = getSurvivedItems(this.order.items, this.order.type, this.order.id_menu);
                    this.replaceOrderItems(survived_items);
                }

                this.setOrderTimeLimit({
                    limit: response.limite_tempo
                });

                this.showModalCartExpired({
                    show: false,
                    error: ''
                });
            }).catch(({messages}) => {
                this.errors = messages;
            }).finally(() => {
                this.loading = false;
            })
        },
        ...mapActions('global', [
            'showModalCartExpired'
        ]),
        ...mapActions('order', {
            setOrderOptions: 'setOptions',
            replaceOrderItems: 'replaceItems',
            setOrderTimeLimit: 'setTimeLimit'
        })
    }
}
</script>
